import _extends from "@babel/runtime/helpers/esm/extends";
import _regeneratorRuntime from "@babel/runtime/helpers/esm/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { Bridge } from "../_";
import { RouteContext, StepsForm } from '@ant-design/pro-components';
import { useBoolean } from 'ahooks';
import { Drawer } from 'antd';
import _ from 'lodash';
import React, { useContext, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { useStyles } from "./_.style";
import { SuperCreatorCard } from "./Card";
export var SuperCreator = function SuperCreator(properties) {
  var _properties$drawer2, _properties$drawer3;
  var intl = Bridge.useIntl();
  var forms = useRef([]);
  var _useStyles = useStyles(),
    styles = _useStyles.styles;
  var value = useContext(RouteContext);
  var _useBoolean = useBoolean(),
    _useBoolean2 = _slicedToArray(_useBoolean, 2),
    creating = _useBoolean2[0],
    creatingAction = _useBoolean2[1];
  var onClose = properties.drawer.onClose || creatingAction.setFalse;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    indicator = _useState2[0],
    setIndicator = _useState2[1];
  var submitterReference = useRef(null);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    onClick: function onClick() {
      var _properties$drawer;
      if (!((_properties$drawer = properties.drawer) !== null && _properties$drawer !== void 0 && _properties$drawer.identifier)) {
        creatingAction.setTrue();
      }
    }
  }, (_properties$drawer2 = properties.drawer) === null || _properties$drawer2 === void 0 ? void 0 : _properties$drawer2.trigger), /*#__PURE__*/React.createElement(Drawer, _extends({
    push: false,
    width: "100%",
    destroyOnClose: true,
    open: ((_properties$drawer3 = properties.drawer) === null || _properties$drawer3 === void 0 ? void 0 : _properties$drawer3.identifier) !== undefined || creating,
    className: styles.container,
    rootStyle: {
      top: 2 * 56,
      height: 'calc(100% - 2 * 56x)'
    },
    styles: {
      header: {
        height: 56
      },
      body: {
        backgroundColor: '#F5F7FA'
      },
      footer: {
        height: 56,
        display: 'flex',
        alignItems: 'center'
      },
      wrapper: {
        boxShadow: 'unset'
      }
    },
    title: /*#__PURE__*/React.createElement("div", {
      style: {
        width: '65%',
        margin: '0 auto',
        display: 'flex',
        position: 'relative',
        left: -28,
        alignItems: 'center'
      }
    }, intl.formatMessage({
      id: 'Create {name}'
    }, {
      name: value.title
    })),
    footer: /*#__PURE__*/React.createElement("div", {
      style: {
        width: '65%',
        display: 'flex',
        margin: '0 auto',
        justifyContent: 'flex-end'
      }
    }, /*#__PURE__*/React.createElement("div", {
      ref: submitterReference
    }))
  }, properties.drawer, {
    onClose: onClose
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      width: '65%',
      margin: 'auto auto',
      overflowY: 'hidden'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'fixed',
      overflowX: 'hidden',
      marginLeft: -128 + 12
    }
  }, indicator), /*#__PURE__*/React.createElement(StepsForm, _extends({
    formMapRef: forms,
    containerStyle: {
      width: '100%',
      overflowY: 'auto',
      maxHeight: 'calc(100vh - 5 * 56px)'
    },
    stepsProps: {
      progressDot: true,
      direction: 'vertical'
    },
    stepsRender: function stepsRender(_steps_, element) {
      //
      if (indicator) {
        // @ts-ignore
        var x = indicator.props.children.props;
        // @ts-ignore
        var y = element.props.children.props;
        if (!_.isEqual(x, y)) {
          setIndicator(element);
        }
      } else {
        if (element) {
          setIndicator(element);
        }
      }
      //
      return /*#__PURE__*/React.createElement(React.Fragment, null);
    },
    submitter: {
      resetButtonProps: {
        style: {
          marginRight: 12
        }
      },
      render: function render(_properties_, element) {
        return submitterReference.current && /*#__PURE__*/createPortal(element, submitterReference.current);
      }
    }
  }, properties.former, {
    onFinish: ( /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(values) {
        var result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!properties.former.onFinish) {
                _context.next = 8;
                break;
              }
              _context.next = 3;
              return properties.former.onFinish(values);
            case 3:
              result = _context.sent;
              if (result) {
                onClose(null);
              }
              return _context.abrupt("return", result);
            case 8:
              return _context.abrupt("return", Promise.reject());
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }()),
    onCurrentChange: function onCurrentChange(current) {
      var _forms$current$at, _forms$current, _properties$former, _properties$former$on;
      // 将 本页 数据同步到 确认信息 页
      (_forms$current$at = forms.current.at(-1)) === null || _forms$current$at === void 0 || (_forms$current$at = _forms$current$at.current) === null || _forms$current$at === void 0 || _forms$current$at.setFieldsValue((_forms$current = forms.current[current - 1]) === null || _forms$current === void 0 || (_forms$current = _forms$current.current) === null || _forms$current === void 0 ? void 0 : _forms$current.getFieldsValue());
      //
      (_properties$former = properties.former) === null || _properties$former === void 0 || (_properties$former$on = _properties$former.onCurrentChange) === null || _properties$former$on === void 0 || _properties$former$on.call(_properties$former, current);
    }
  }), properties.children))));
};
SuperCreator.Card = SuperCreatorCard;